import { FC } from 'react';

import Select, { SelectProps } from 'components/Select';

type Props = Omit<SelectProps, 'options'>;

const options = [
  {
    value: 'ALIAS',
    label: 'Alias',
  },
  {
    value: 'PERMANENT_REDIRECT',
    label: '301',
  },
  {
    value: 'REDIRECT',
    label: '302',
  },
];

const SeoRouteTypeSelect: FC<Props> = props => (
  <Select options={options} {...props} />
);

export default SeoRouteTypeSelect;
